import { useApi } from '@/api';
import { ChartSkeleton, ChartTimeFilter } from '@/components';
import {
  Flex,
  LineChart,
  FormattedNumber,
  formatNumber
} from '@blockanalitica/ui';
import { useMemo, useState } from 'react';

export default function HistoricTabs() {
  const [chartDaysAgo, setChartDaysAgo] = useState('30');
  const [data, error] = useApi({
    url: '/groups/core/historic/',
    queryParams: {
      days_ago: chartDaysAgo
    }
  });

  if (error) {
    throw error;
  }

  const timeFilter = useMemo(
    () => (
      <ChartTimeFilter activeOption={chartDaysAgo} onChange={setChartDaysAgo} />
    ),
    [chartDaysAgo]
  );

  if (data) {
    return (
      <Flex flexDirection="column" gap="xs">
        <LineChart
          key="num_urns"
          data={data}
          datasets={[
            {
              xField: 'date',
              yField: 'num_urns'
            }
          ]}
          timeFilter={timeFilter}
          valueFormatter={(value: number) => (
            <FormattedNumber
              value={Number(value)}
              options={{ formatNumberOptions: { notation: 'standard' } }}
            />
          )}
          yScaleValueFormatter={(value: number) =>
            formatNumber(value, { notation: 'standard' })
          }
        />
      </Flex>
    );
  }
  return <ChartSkeleton />;
}
